import { useRef } from "react";
import { Button } from "react-bootstrap";

const SideImage = ({ onSelectImage, style = {}, className = "" }) => {
  const ref = useRef();
  const handleButtonClick = () => {
    ref.current?.click(); // Triggers file input
  };
  return (
    <>
      <input
        ref={ref}
        type="file"
        onChange={(event) => {
          onSelectImage(event);
          if (event.target.value) 
          event.target.value = "";
        }}
        style={{ display: "none" }}
      />
      <Button
        style={{ minWidth: "unset", ...style}}
        onClick={handleButtonClick}
        className={"side-link ms-2 btn btn-secondary-light btn-sm " + className}
        variant="secondary-light"
      >
        Add Image
      </Button>
    </>
  );
};

export default SideImage;
